import Furniture from './Furniture';
import Heart from 'app/campout/Heart';

export default class Pond extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    //
    this.waterLevel = 1;
    this.waterDestLevel = 1;
    this.isFrog = true;

    //
    this.areas = this.data.areas;

    // this.renderAreas();

    // mix anims
    this.asset.setMixByName('press', 'jump_out', 0.2);

    //
    this.ambience = this.game.sounds
      .playSFX('ambience_brook', {
        spriteID: 'sfx',
        loop: true,
        volume: 0,
      })
      .get('ambience_brook');
  }

  /* eslint-disable max-statements */
  createAsset() {
    this.riverBack = this.game.make.image(464, -417, this.data.key, 'river_back');
    this.riverBack.anchor.set(0.5);
    this.riverMid = this.game.make.image(76, -342, this.data.key, 'rivermid');
    this.riverMid.anchor.set(0.5);
    this.rockSide1 = this.game.make.image(20, -277, this.data.key, 'rockside_1');
    this.rockSide1.anchor.set(0.5);
    this.rockSide2 = this.game.make.image(115, -267, this.data.key, 'rockside_2');
    this.rockSide2.anchor.set(0.5);
    this.tinyStone = this.game.make.image(67, -279, this.data.key, 'tinystone');
    this.tinyStone.anchor.set(0.5);

    this.whole = this.game.make.image(-9, -171, this.data.key, 'pond_whole');
    this.whole.anchor.set(0.5);

    this.backFlood = this.game.make.image(95, -367, this.data.key, 'back_flood');
    this.backFlood.anchor.set(0.5);
    this.water = this.game.make.image(16, -145, this.data.key, 'water');
    this.water.anchor.set(0.5);
    this.waterRock = this.game.make.image(65, -278, this.data.key, 'rock_water');
    this.waterRock.anchor.set(0.5);
    this.waterFront = this.game.make.image(14, -68, this.data.key, 'water_front');
    this.waterFront.anchor.set(0.5);
    this.waterFrog = this.game.make.image(303, -31, this.data.key, 'water_frog');
    this.waterFrog.anchor.set(0.5);

    this.plant = this.game.make.image(141, -309, this.data.key, 'plant');
    this.plant.anchor.set(0.5);

    this.rocks = this.game.make.image(436, -99, this.data.key, 'rocks');
    this.rocks.anchor.set(0.5);

    // frog
    this.asset = this.game.make.spine(0, 0, 'spine_frog', true);
    this.asset.anchor.set(0.5, 1);
    this.setAnim('idle');

    // container for slots
    this.surfaceY = this.waterFront.y - this.waterFront.height * 0.5;
    this.containerTop = this.game.make.group();
    this.containerTop.y = this.surfaceY;
    this.containerBtm = this.game.make.group();
    this.containerBtm.y = -50;

    //
    this.addChild(this.riverBack);
    this.addChild(this.riverMid);
    this.addChild(this.backFlood);
    this.addChild(this.rockSide1);
    this.addChild(this.rockSide2);
    this.addChild(this.tinyStone);
    this.addChild(this.waterRock);
    this.addChild(this.whole);
    this.addChild(this.water);
    this.addChild(this.plant);

    this.backFlood.alpha = 0;
  }
  /* eslint-enable */

  //
  initLayers() {
    this.containerTop.x += this.x;
    this.containerTop.y += this.y;
    this.containerBtm.x += this.x;
    this.containerBtm.y += this.y;
    this.waterFront.x += this.x;
    this.waterFront.y += this.y;
    this.asset.x += this.x;
    this.asset.y += this.y;
    this.waterFrog.x += this.x;
    this.waterFrog.y += this.y;
    this.rocks.x += this.x;
    this.rocks.y += this.y;

    this.containerTop.depth = this.containerTop.y;
    this.containerBtm.depth = this.containerBtm.y;
    this.waterFront.depth = this.waterFront.y + this.waterFront.height * 0.5;
    this.asset.depth = this.asset.y + 5;
    this.waterFrog.depth = this.waterFrog.y + this.waterFrog.height * 0.5;
    this.rocks.depth = this.rocks.y + this.rocks.height * 0.5;

    this.parent.addChild(this.containerTop);
    this.parent.addChild(this.containerBtm);
    this.parent.addChild(this.waterFront);
    this.parent.addChild(this.asset);
    this.parent.addChild(this.waterFrog);
    this.parent.addChild(this.rocks);

    // set restored water level
    if (!isNaN(this.data.water_level)) {
      this.waterLevel = this.data.water_level;
      this.displayWaterLevel();
    }
  }

  addRock(rock) {
    this.addChildAt(rock, this.getChildIndex(this.rockSide1));
  }

  //
  setLight(power) {
    super.setLight(power);
    super.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.riverBack.tint = this.tintColor;
    this.riverMid.tint = this.tintColor;
    this.rockSide1.tint = this.tintColor;
    this.rockSide2.tint = this.tintColor;
    this.tinyStone.tint = this.tintColor;
    this.plant.tint = this.tintColor;

    this.whole.tint = this.tintColor;
    this.backFlood.tint = this.tintColor;
    this.water.tint = this.tintColor;
    this.waterFront.tint = this.tintColor;
    this.waterFrog.tint = this.tintColor;
    this.waterRock.tint = this.tintColor;
    this.rocks.tint = this.tintColor;
  }

  handleInputDown() {
    if (this.isFrog) {
      this.setAnim('press', false);
      this.asset.addAnimationByName(0, 'idle', true);
      this.game.sounds.playSFX('item_frog', { spriteID: 'sfx', ignoreIfPlaying: true });
    }
  }

  //
  waterDown() {
    this.waterDestLevel = 0;
  }

  waterUp() {
    this.waterDestLevel = 1;
  }

  step(dt) {
    super.step(dt);

    // water level
    if (this.waterLevel !== this.waterDestLevel) {
      const dir = this.waterDestLevel > this.waterLevel ? 1 : -1;
      this.waterLevel += dt * 0.3 * dir;

      if (this.waterLevel > 1 || this.waterLevel < 0) {
        this.waterLevel = this.waterDestLevel;

        this.onChange.dispatch();
      }

      this.displayWaterLevel();
    }

    // frog animations
    if (this.isFrog && this.waterLevel < 0.5) {
      // frog escapes
      this.isFrog = false;
      this.setAnim('jump_out', false);
      this.game.sounds.playSFX('item_frog', { spriteID: 'sfx' });
    } else if (!this.isFrog && this.waterLevel > 0.5) {
      // frog returns
      this.isFrog = true;
      this.setAnim('jump_in', false);
      this.game.sounds.playSFX('item_frog', { spriteID: 'sfx' });

      this.game.time.events.add(300, this.showHeart, this);
    }

    // audio volume
    if (this.ambience) {
      const left = -this.location.x;
      const right = left + this.game.width;
      const width = (right - left) * 0.5;
      const mid = (right + left) * 0.5;
      const x = this.x;
      let volume = 0;
      if (x < right && x > left) {
        volume = 1 - Math.abs(x - mid) / width;
      } else {
        volume = 0;
      }
      volume *= 0.5 + 0.5 * this.waterLevel;

      this.ambience.volume = volume;
    }
  }

  showHeart() {
    const heart = new Heart(this.game, 320, -130);
    this.addChild(heart);
  }

  displayWaterLevel() {
    const dy = (1 - this.waterLevel) * 58; // 48
    this.water.y = -145 + dy;
    this.waterFront.y = this.y - 68 + dy;
    this.waterFrog.y = this.y - 31 + dy;
    this.waterRock.y = -278 + dy;

    this.backFlood.alpha = 1 - this.waterLevel;
    this.backFlood.scale.x = 1 + 0.14 * (1 - this.waterLevel);
    this.backFlood.scale.y = 1 + 0.04 * (1 - this.waterLevel);

    this.surfaceY = this.waterFront.y - this.waterFront.height * 0.5;
    this.containerTop.y = this.surfaceY;
  }

  //
  isItemAbove(item) {
    const bb1 = new Phaser.Rectangle();
    this.areaOver = null;
    const area = this.areas[0];
    bb1.x = this.x + this.whole.x - this.whole.width * 0.5 + area.x;
    bb1.y = 0;
    bb1.width = area.w;
    bb1.height = 720;

    if (Phaser.Rectangle.contains(bb1, item.x, Math.min(719, item.y))) {
      return true;
    }

    return false;
  }

  // does item overlap any of the pond rectangles
  isItemOver(item) {
    const bb1 = new Phaser.Rectangle();
    this.areaOver = null;
    for (let i = 0; i < this.areas.length; i++) {
      const area = this.areas[i];
      bb1.x = this.x + this.whole.x - this.whole.width * 0.5 + area.x;
      bb1.y = this.y - this.whole.height + area.y;
      bb1.width = area.w;
      bb1.height = area.h;

      if (Phaser.Rectangle.contains(bb1, item.x, Math.min(719, item.y))) {
        this.areaOver = area;
        return true;
      }
    }

    return false;
  }

  renderAreas() {
    this.debugGR = this.game.make.graphics(0, 0);
    this.location.foreground.addChild(this.debugGR);
    this.debugGR.beginFill(0xff0000, 0.7);
    for (let i = 0; i < this.areas.length; i++) {
      const area = this.areas[i];
      const x = this.x + this.whole.x - this.whole.width * 0.5 + area.x;
      const y = this.y - this.whole.height + area.y;
      const width = area.w;
      const height = area.h;
      // console.log(x, y, width, height);

      this.debugGR.drawRect(x, y, width, height);
    }

    return false;
  }

  dropItemInto(item) {
    item;
    item.inPond = true;
    item.pond = this;
    item.x = item.x - this.containerTop.x;
    item.x = Phaser.Math.clamp(
      item.x,
      -this.waterFront.width * 0.5 + 100,
      this.waterFront.width * 0.5 - 100
    );
    item.dz = this.y;
    if (item.canFloat()) {
      this.containerTop.addChild(item);
      item.y = item.y - this.containerTop.y;
      let destY = Math.min(25, item.height * 0.4);
      if (item.id === 'leaf_boat') {
        destY = 5;
      }
      item.fallDownTo(destY);
      item.startWaving();
    } else {
      this.containerBtm.addChild(item);
      item.y = item.y - this.containerBtm.y;
      item.fallDownTo(0);
    }
  }

  addInto(item) {
    if (item.canFloat()) {
      this.containerTop.addChild(item);
      item.destY = item.y;
      item.startWaving();
    } else {
      this.containerBtm.addChild(item);
    }
  }

  dropItemNextTo(item) {
    item;
  }

  //
  serialize() {
    const data = super.serialize();
    data.water_level = this.waterLevel;
    return data;
  }
}
